import departmentsApi from 'Api/axios/departments-api';
import { useState, useEffect } from 'react';
import type { DepartmentFilterI, DepartmentI } from 'types';

interface Props {
  init?: boolean;
}

const useDepartmentsApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<Array<DepartmentI>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDepartments = async (filters: DepartmentFilterI = {}) => {
    setLoading(true);
    const response = await departmentsApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchDepartments();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchDepartments,
  };
};

export default useDepartmentsApi;
